// Lightweight i18n dictionary for Metazik (FR + EN)
export const translations = {
  fr: {
    appName: "Metazik",
    tagline: "Vivez la musique. Soutenez vos artistes.",
    nav: { feed: "Fil", store: "Boutique", library: "Bibliothèque", agenda: "Agenda", lives: "Lives", challenges: "Défis", discover: "Découvrir", profile: "Profil", logout: "Déconnexion", login: "Connexion", signup: "Inscription" },
    auth: {
      welcome: "Bienvenue sur Metazik",
      sub: "Le réseau social et la boutique de musique des artistes indépendants.",
      email: "Adresse email",
      password: "Mot de passe",
      name: "Nom d'artiste ou pseudo",
      pseudo: "Pseudo",
      role: "Je suis...",
      roleArtist: "Artiste",
      roleArtistDesc: "Publier des photos, vendre ma musique, animer des lives",
      roleViewer: "Fan",
      roleViewerDesc: "Découvrir, acheter et soutenir les artistes",
      gender: "Genre (optionnel)",
      genderMale: "Homme",
      genderFemale: "Femme",
      genderUnspecified: "Préfère ne pas dire",
      signIn: "Se connecter",
      signUp: "Créer mon compte",
      switchToSignup: "Pas encore de compte ? Inscrivez-vous",
      switchToLogin: "Déjà un compte ? Connectez-vous",
      orContinue: "ou",
      lang: "Langue",
      showPassword: "Afficher le mot de passe",
      hidePassword: "Masquer le mot de passe",
      acceptTerms: "J'accepte les",
      termsLink: "Conditions d'utilisation",
      andThe: "et la",
      privacyLink: "Politique de confidentialité",
      mustAcceptTerms: "Vous devez accepter les conditions pour vous inscrire.",
    },
    feed: {
      title: "Fil d'actualité",
      empty: "Pas encore de publications. Soyez le premier !",
      loadError: "Le fil n'a pas pu charger — le serveur met parfois quelques secondes à répondre.",
      retry: "Réessayer",
      compose: "Quoi de neuf ?",
      publish: "Publier",
      addImage: "Photo (URL)",
      attachTrack: "Joindre un morceau",
      none: "Aucun",
      like: "J'aime",
      comment: "Commenter",
      comments: "Commentaires",
      writeComment: "Écrire un commentaire...",
      writeReply: "Écrire une réponse...",
      reply: "Répondre",
      send: "Envoyer",
      photoLabel: "Ajouter une photo",
      trackLabel: "Joindre un morceau",
      tabGlobal: "Global",
      tabFollowing: "Abonnements",
      loadMore: "Charger plus",
    },
    store: {
      title: "Boutique",
      sub: "Découvrez et achetez la musique des artistes Metazik.",
      buy: "Acheter",
      owned: "Acheté",
      preview: "Aperçu",
      filterAll: "Tout",
      typeSingle: "Single",
      typeAlbum: "Album",
      typeEP: "EP",
      typeMaxi: "Maxi Single",
      loadError: "La boutique n'a pas pu charger — le serveur met parfois quelques secondes à répondre.",
      retry: "Réessayer",
    },
    purchase: {
      title: "Finaliser l'achat",
      track: "Morceau",
      price: "Prix",
      method: "Mode de paiement",
      country: "Ton pays",
      countryOther: "Autre pays / Carte bancaire",
      stripe: "Carte bancaire (Stripe)",
      mobile: "Mobile Money",
      airtel: "Airtel Money",
      mtn: "MTN Mobile Money",
      orange: "Orange Money",
      mobicash: "Mobicash",
      phone: "Numéro mobile",
      cancel: "Annuler",
      pay: "Payer maintenant",
      success: "Paiement réussi ! Le morceau est dans votre bibliothèque.",
      demoNotice: "Mode démo : paiement simulé. Aucune transaction réelle.",
      loadingMethods: "Chargement des moyens de paiement…",
      noMethods: "Aucun moyen de paiement disponible pour cette devise en ce moment.",
      error: "Une erreur est survenue, réessayez.",
      back: "Retour",
      currencyStep: "Dans quelle devise veux-tu payer ?",
      detailsStep: "Numéro Mobile Money",
    },
    library: {
      title: "Ma bibliothèque",
      empty: "Votre bibliothèque est vide. Achetez vos premiers morceaux.",
      loadError: "La bibliothèque n'a pas pu charger — le serveur met parfois quelques secondes à répondre.",
      retry: "Réessayer",
      goStore: "Aller à la boutique",
      allTracks: "Tous mes morceaux",
      newPlaylist: "Nouvelle playlist",
      newPlaylistTitle: "Créer une playlist",
      playlistNamePh: "Ex : Zouk, Sport, Danse…",
      create: "Créer",
      cancel: "Annuler",
      addToPlaylist: "Ajouter à une playlist",
      removeFromPlaylist: "Retirer de la playlist",
      deletePlaylist: "Supprimer la playlist",
      renamePlaylist: "Renommer",
      emptyPlaylist: "Cette playlist est vide pour l'instant.",
      offlineReady: "Disponible hors-ligne",
      offlineBadge: "Hors-ligne",
    },
    profile: {
      edit: "Modifier le profil",
      save: "Enregistrer",
      bio: "Bio",
      avatar: "Avatar (URL)",
      cover: "Photo de couverture (URL)",
      tracks: "Morceaux",
      posts: "Publications",
      photos: "Photos",
      noPhotos: "Aucune photo publiée.",
      events: "Agenda",
      followers: "Abonnés",
      followingLabel: "Abonnements",
      follow: "Suivre",
      following: "Suivi(e)",
      goLive: "Passer en direct",
      stopLive: "Arrêter le live",
      newTrack: "Publier un morceau",
      newPhoto: "Photo",
      newSong: "Chanson",
      newProject: "Projet",
      news: "Actualité",
      noChallenges: "Aucun défi participé pour l'instant.",
      editCover: "Modifier la couverture",
      title2: "Titre",
      coverUrl: "URL de la pochette",
      audioUrl: "URL audio",
      price: "Prix (USD)",
      genre: "Genre",
      discography: "Discographie",
      singles: "Singles",
      albums: "Albums",
      eps: "EP",
      maxis: "Maxi Singles",
      searchTrack: "Rechercher un morceau...",
      noReleases: "Aucune sortie dans cette catégorie.",
      releaseType: "Type de sortie",
      freeTrack: "Morceau gratuit (téléchargement libre)",
      previewStart: "Aperçu : début (s)",
      previewDuration: "Aperçu : durée (s)",
      creditsTitle: "Crédits du morceau",
      featPh: "Feat. (séparer par virgule)",
      prodPh: "Producteurs / beatmakers (virgule)",
      authorPh: "Auteur(s) des paroles (virgule)",
      composerPh: "Compositeur(s) (virgule)",
      labelPh: "Label (optionnel)",
      uploadCover: "Téléverser la pochette (JPEG, PNG, WebP, HEIC)",
      uploadAudio: "Téléverser le morceau (MP3 ou WAV)",
    },
    agenda: {
      title: "Agenda des concerts",
      sub: "Concerts, dédicaces et rencontres à venir.",
      add: "Ajouter un événement",
      name: "Titre de l'événement",
      desc: "Description",
      location: "Lieu",
      date: "Date",
      type: "Type",
      types: { concert: "Concert", signing: "Dédicace", meetup: "Rencontre", other: "Autre" },
      empty: "Aucun événement programmé.",
      create: "Créer",
    },
    lives: {
      title: "Lives en direct",
      sub: "Rejoignez vos artistes maintenant.",
      empty: "Aucun live en cours.",
      viewers: "spectateurs",
      join: "Rejoindre",
      goLive: "Démarrer un live",
      enterTitle: "Titre de votre live",
      start: "Démarrer",
    },
    common: { close: "Fermer", loading: "Chargement...", play: "Lire", pause: "Pause" },
    stories: {
      add: "Ajouter",
      empty: "Aucune story pour le moment.",
      newStory: "Nouvelle story",
      imageUrl: "URL de l'image",
      uploadImage: "Téléverser une photo (JPEG, PNG, WebP, HEIC)",
      captionPh: "Légende (optionnel)",
      publish: "Publier la story",
    },
    dashboard: {
      title: "Tableau de bord",
      tracks: "Morceaux",
      sales: "Ventes",
      salesShort: "ventes",
      revenue: "Revenus",
      likes: "J'aime",
      dislikes: "J'aime pas",
      searchPh: "Rechercher un morceau...",
      noTracks: "Aucun morceau publié.",
      backToProfile: "← Mon profil",
      cover: "Pochette",
      col_title: "Titre",
      col_type: "Type",
      col_sales: "Ventes",
      col_revenue: "Revenus",
      col_likes: "J'aime",
      col_dislikes: "J'aime pas",
      goDashboard: "Tableau de bord",
    },
    challenges: {
      title: "Défis",
      sub: "Lancez ou rejoignez les défis musicaux. Le meilleur fan remporte le prix.",
      create: "Lancer un défi",
      empty: "Aucun défi pour le moment.",
      ended: "Terminé",
      winner: "Gagnant",
      submissions: "soumissions",
      submit: "Participer",
      submitTitle: "Soumettez votre vidéo",
      videoUrl: "Lien de votre vidéo (TikTok, YouTube...)",
      uploadVideo: "Téléverser votre vidéo (MP4, WebM, MOV)",
      captionPh: "Légende (optionnel)",
      leaderboard: "Classement",
      noSubmissions: "Soyez le premier à participer !",
      titlePh: "Titre du défi",
      descPh: "Décrivez le défi en quelques mots",
      pickTrack: "Choisir un morceau",
      prizePh: "Prix (montant)",
      currencyPh: "FCFA",
      durationPh: "Durée en jours",
      launch: "Lancer le défi",
      uploadAnnounce: "Téléverser une vidéo d'annonce (optionnel)",
      announce: "Vidéo d'annonce",
    },
    audio: {
      previewEnded: "Extrait terminé. Achète la chanson pour l'écouter en entier.",
      previewLabel: "Extrait",
      lyrics: "Paroles",
      noLyrics: "Paroles non disponibles pour ce morceau.",
      fullPlayer: "Lecteur complet",
    },
    tips: {
      title: "Envoyer un tip",
      sub: "Soutenez l'artiste pendant son live —",
      send: "Envoyer",
      messagePh: "Petit mot pour l'artiste (optionnel)",
      thankYou: "Merci pour votre tip !",
      invalidAmount: "Montant entre 1 et 10 000 FCFA",
      demoNotice: "Mode démo : paiement simulé (sandbox). Brancher vraies clés Stripe / Mobile Money plus tard.",
    },
    search: {
      placeholder: "Rechercher artistes, morceaux, posts…",
      artists: "Artistes",
      tracks: "Morceaux",
      posts: "Publications",
      empty: "Aucun résultat",
    },
    notifications: {
      title: "Notifications",
      empty: "Aucune notification.",
      markAll: "Tout marquer lu",
      follow: "vous suit maintenant",
      tip: "vous a envoyé un pourboire",
      like: "a aimé votre publication",
      comment: "a commenté votre publication",
      live: "est en direct",
      post: "a publié",
      track: "a sorti un nouveau morceau",
    },
    legal: {
      privacy: "Politique de confidentialité",
      terms: "Conditions d'utilisation",
      general: "Politique générale",
      backToHome: "Retour à l'accueil",
    },
    errors: {
      "Invalid email or password": "Identifiants incorrects",
      "Email already registered": "Cet email est déjà utilisé",
      "Not authenticated": "Vous n'êtes pas connecté",
      "Token expired": "Session expirée, reconnectez-vous",
      "Invalid token": "Session invalide, reconnectez-vous",
      "User not found": "Utilisateur introuvable",
      "Track not found": "Morceau introuvable",
      "Already purchased": "Vous possédez déjà ce morceau",
      "Only artists can publish tracks": "Seuls les artistes peuvent publier des morceaux",
      "Only artists can create events": "Seuls les artistes peuvent créer des événements",
      "Only artists can go live": "Seuls les artistes peuvent passer en direct",
      "Forbidden": "Accès refusé",
      "Not found": "Introuvable",
      "Live not found": "Direct introuvable",
      "Live is not active": "Le direct n'est plus actif",
      "You cannot tip yourself": "Vous ne pouvez pas vous donner un pourboire",
      "Could not send tip": "Impossible d'envoyer le pourboire",
      "Could not update like": "Impossible de mettre à jour le j'aime",
      "Could not save": "Impossible d'enregistrer",
      "Could not publish": "Impossible de publier",
      "Could not create": "Impossible de créer",
      "Could not delete": "Impossible de supprimer",
      "Could not start live": "Impossible de démarrer le live",
      "Could not join": "Impossible de rejoindre",
      "Something went wrong.": "Une erreur est survenue.",
      "Sign in to interact": "Connectez-vous pour interagir",
      "Sign in to comment": "Connectez-vous pour commenter",
      "Posted!": "Publié !",
      "Profile updated": "Profil mis à jour",
      "Track published": "Morceau publié",
      "Playlist created": "Playlist créée",
      "Added to playlist": "Ajouté à la playlist",
      "Event created": "Événement créé",
      "You are live!": "Vous êtes en direct !",
      "Live ended": "Live terminé",
      "Deleted": "Supprimé",
    },
    onboarding: {
      title: "Bienvenue chez Metazik 🎶",
      intro: "Voici ce que vous pouvez faire en tant qu'artiste sur la plateforme :",
      feed: "Publiez dans le fil d'actualité — photos, actus, coulisses — pour rester proche de vos fans.",
      sell: "Mettez vos morceaux en vente directement depuis votre profil.",
      agenda: "Ajoutez vos concerts et événements à votre agenda pour que vos fans sachent où vous retrouver.",
      stories: "Publiez des stories pour partager des moments en direct avec votre communauté.",
      photos: "Ajoutez des photos professionnelles à votre profil et vos publications.",
      cta: "Compris, je me lance !",
    },
    deleteAccount: {
      link: "Supprimer mon compte",
      title: "Supprimer mon compte",
      warnArtist: "Ton profil, tes publications, stories, événements, lives et les morceaux que personne n'a achetés seront supprimés définitivement. Les morceaux que des fans ont déjà achetés restent dans leur bibliothèque, avec ton nom d'artiste, mais ne seront plus en vente.",
      warnFan: "Ton profil, tes playlists, likes, commentaires et abonnements seront supprimés définitivement, et tu perdras l'accès à ta bibliothèque de musique.",
      passwordLabel: "Confirme avec ton mot de passe",
      confirm: "Supprimer définitivement",
      confirmForfeit: "J'accepte de perdre ce solde — supprimer",
      cancel: "Annuler",
      done: "Ton compte a été supprimé.",
      network: "Impossible de joindre le serveur, réessaie dans un instant.",
    },
  },
  en: {
    appName: "Metazik",
    tagline: "Feel the music. Support your artists.",
    nav: { feed: "Feed", store: "Store", library: "Library", agenda: "Agenda", lives: "Lives", challenges: "Challenges", discover: "Discover", profile: "Profile", logout: "Log out", login: "Log in", signup: "Sign up" },
    auth: {
      welcome: "Welcome to Metazik",
      sub: "The social network and music store for independent artists.",
      email: "Email",
      password: "Password",
      name: "Artist name or username",
      pseudo: "Username",
      role: "I am a...",
      roleArtist: "Artist",
      roleArtistDesc: "Post photos, sell my music, host live streams",
      roleViewer: "Fan",
      roleViewerDesc: "Discover, buy and support artists",
      gender: "Gender (optional)",
      genderMale: "Male",
      genderFemale: "Female",
      genderUnspecified: "Prefer not to say",
      signIn: "Sign in",
      signUp: "Create my account",
      switchToSignup: "No account yet? Sign up",
      switchToLogin: "Already have an account? Log in",
      orContinue: "or",
      lang: "Language",
      showPassword: "Show password",
      hidePassword: "Hide password",
      acceptTerms: "I accept the",
      termsLink: "Terms of Use",
      andThe: "and the",
      privacyLink: "Privacy Policy",
      mustAcceptTerms: "You must accept the terms to sign up.",
    },
    feed: {
      title: "Feed",
      empty: "No posts yet. Be the first!",
      loadError: "The feed couldn't load — the server sometimes takes a few seconds to respond.",
      retry: "Retry",
      compose: "What's new?",
      publish: "Publish",
      addImage: "Image (URL)",
      attachTrack: "Attach a track",
      none: "None",
      like: "Like",
      comment: "Comment",
      comments: "Comments",
      writeComment: "Write a comment...",
      writeReply: "Write a reply...",
      reply: "Reply",
      send: "Send",
      photoLabel: "Add a photo",
      trackLabel: "Attach a track",
      tabGlobal: "Global",
      tabFollowing: "Following",
      loadMore: "Load more",
    },
    store: {
      title: "Store",
      sub: "Discover and buy music from Metazik artists.",
      buy: "Buy",
      owned: "Owned",
      preview: "Preview",
      filterAll: "All",
      typeSingle: "Single",
      typeAlbum: "Album",
      typeEP: "EP",
      typeMaxi: "Maxi Single",
      loadError: "The store couldn't load — the server sometimes takes a few seconds to respond.",
      retry: "Retry",
    },
    purchase: {
      title: "Complete your purchase",
      track: "Track",
      price: "Price",
      method: "Payment method",
      country: "Your country",
      countryOther: "Other country / Card",
      stripe: "Credit card (Stripe)",
      mobile: "Mobile Money",
      airtel: "Airtel Money",
      mtn: "MTN Mobile Money",
      orange: "Orange Money",
      mobicash: "Mobicash",
      phone: "Mobile number",
      cancel: "Cancel",
      pay: "Pay now",
      success: "Payment successful! The track is in your library.",
      demoNotice: "Demo mode: simulated payment. No real transaction.",
      loadingMethods: "Loading payment methods…",
      noMethods: "No payment method available for this currency right now.",
      error: "Something went wrong, please try again.",
      back: "Back",
      currencyStep: "Which currency do you want to pay in?",
      detailsStep: "Mobile Money number",
    },
    library: {
      title: "My library",
      empty: "Your library is empty. Buy your first tracks.",
      loadError: "The library couldn't load — the server sometimes takes a few seconds to respond.",
      retry: "Retry",
      goStore: "Go to the store",
      allTracks: "All my tracks",
      newPlaylist: "New playlist",
      newPlaylistTitle: "Create a playlist",
      playlistNamePh: "E.g. Zouk, Workout, Dance…",
      create: "Create",
      cancel: "Cancel",
      addToPlaylist: "Add to a playlist",
      removeFromPlaylist: "Remove from playlist",
      deletePlaylist: "Delete playlist",
      renamePlaylist: "Rename",
      emptyPlaylist: "This playlist is empty for now.",
      offlineReady: "Available offline",
      offlineBadge: "Offline",
    },
    profile: {
      edit: "Edit profile",
      save: "Save",
      bio: "Bio",
      avatar: "Avatar (URL)",
      cover: "Cover photo (URL)",
      tracks: "Tracks",
      posts: "Posts",
      photos: "Photos",
      noPhotos: "No photos posted yet.",
      events: "Agenda",
      followers: "Followers",
      followingLabel: "Following",
      follow: "Follow",
      following: "Following",
      goLive: "Go live",
      stopLive: "Stop live",
      newTrack: "Publish a track",
      newPhoto: "Photo",
      newSong: "Song",
      newProject: "Project",
      news: "News",
      noChallenges: "No challenges yet.",
      editCover: "Edit cover",
      title2: "Title",
      coverUrl: "Cover URL",
      audioUrl: "Audio URL",
      price: "Price (USD)",
      genre: "Genre",
      discography: "Discography",
      singles: "Singles",
      albums: "Albums",
      eps: "EP",
      maxis: "Maxi Singles",
      searchTrack: "Search a track...",
      noReleases: "No releases in this category.",
      releaseType: "Release type",
      freeTrack: "Free track (open download)",
      previewStart: "Preview start (s)",
      previewDuration: "Preview length (s)",
      creditsTitle: "Track credits",
      featPh: "Feat. (comma-separated)",
      prodPh: "Producers / beatmakers (comma)",
      authorPh: "Lyrics author(s) (comma)",
      composerPh: "Composer(s) (comma)",
      labelPh: "Label (optional)",
      uploadCover: "Upload cover (JPEG, PNG, WebP, HEIC)",
      uploadAudio: "Upload audio (MP3 or WAV)",
    },
    agenda: {
      title: "Concert agenda",
      sub: "Upcoming concerts, signings and meetups.",
      add: "Add an event",
      name: "Event title",
      desc: "Description",
      location: "Location",
      date: "Date",
      type: "Type",
      types: { concert: "Concert", signing: "Signing", meetup: "Meetup", other: "Other" },
      empty: "No upcoming events.",
      create: "Create",
    },
    lives: {
      title: "Live streams",
      sub: "Join your artists right now.",
      empty: "No active live streams.",
      viewers: "viewers",
      join: "Join",
      goLive: "Start a live",
      enterTitle: "Title of your live",
      start: "Start",
    },
    common: { close: "Close", loading: "Loading...", play: "Play", pause: "Pause" },
    stories: {
      add: "Add",
      empty: "No stories yet.",
      newStory: "New story",
      imageUrl: "Image URL",
      uploadImage: "Upload a photo (JPEG, PNG, WebP, HEIC)",
      captionPh: "Caption (optional)",
      publish: "Publish story",
    },
    dashboard: {
      title: "Dashboard",
      tracks: "Tracks",
      sales: "Sales",
      salesShort: "sales",
      revenue: "Revenue",
      likes: "Likes",
      dislikes: "Dislikes",
      searchPh: "Search a track...",
      noTracks: "No tracks published.",
      backToProfile: "← My profile",
      cover: "Cover",
      col_title: "Title",
      col_type: "Type",
      col_sales: "Sales",
      col_revenue: "Revenue",
      col_likes: "Likes",
      col_dislikes: "Dislikes",
      goDashboard: "Dashboard",
    },
    challenges: {
      title: "Challenges",
      sub: "Launch or join music challenges. The top fan wins the prize.",
      create: "Launch a challenge",
      empty: "No challenges yet.",
      ended: "Ended",
      winner: "Winner",
      submissions: "submissions",
      submit: "Participate",
      submitTitle: "Submit your video",
      videoUrl: "Video URL (TikTok, YouTube...)",
      uploadVideo: "Upload your video (MP4, WebM, MOV)",
      captionPh: "Caption (optional)",
      leaderboard: "Leaderboard",
      noSubmissions: "Be the first to participate!",
      titlePh: "Challenge title",
      descPh: "Describe the challenge",
      pickTrack: "Pick a track",
      prizePh: "Prize amount",
      currencyPh: "FCFA",
      durationPh: "Duration in days",
      launch: "Launch challenge",
    },
    audio: {
      previewEnded: "Preview ended. Buy the track to listen in full.",
      previewLabel: "Preview",
      lyrics: "Lyrics",
      noLyrics: "No lyrics available for this track.",
      fullPlayer: "Full Player",
    },
    tips: {
      title: "Send a tip",
      sub: "Support the artist during their live —",
      send: "Send",
      messagePh: "Short message to the artist (optional)",
      thankYou: "Thanks for your tip!",
      invalidAmount: "Amount between 1 and 10,000 FCFA",
      demoNotice: "Demo mode: simulated payment (sandbox). Real Stripe / Mobile Money keys to plug in later.",
    },
    search: {
      placeholder: "Search artists, tracks, posts…",
      artists: "Artists",
      tracks: "Tracks",
      posts: "Posts",
      empty: "No results",
    },
    notifications: {
      title: "Notifications",
      empty: "No notifications yet.",
      markAll: "Mark all read",
      follow: "is now following you",
      tip: "sent you a tip",
      like: "liked your post",
      comment: "commented on your post",
      live: "is live now",
      post: "posted",
      track: "released a new track",
    },
    onboarding: {
      title: "Welcome to Metazik 🎶",
      intro: "Here's what you can do as an artist on the platform:",
      feed: "Post to the feed — photos, updates, behind-the-scenes — to stay close to your fans.",
      sell: "Put your tracks up for sale directly from your profile.",
      agenda: "Add your shows and events to your agenda so fans know where to find you.",
      stories: "Post stories to share live moments with your community.",
      photos: "Add professional photos to your profile and posts.",
      cta: "Got it, let's go!",
    },
    deleteAccount: {
      link: "Delete my account",
      title: "Delete my account",
      warnArtist: "Your profile, posts, stories, events, lives and any track nobody has bought will be permanently deleted. Tracks that fans have already bought stay in their library, credited to your artist name, but will no longer be on sale.",
      warnFan: "Your profile, playlists, likes, comments and follows will be permanently deleted, and you will lose access to your music library.",
      passwordLabel: "Confirm with your password",
      confirm: "Delete permanently",
      confirmForfeit: "I accept losing this balance — delete",
      cancel: "Cancel",
      done: "Your account has been deleted.",
      network: "Couldn't reach the server, please try again in a moment.",
    },
    legal: {
      privacy: "Privacy Policy",
      terms: "Terms of Use",
      general: "General Policy",
      backToHome: "Back to home",
    },
    errors: {},
  },
};

export function getT(lang) {
  return translations[lang] || translations.en;
}
